let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("01lMu")).then(() => parcelRequire('8qqVD'));